import { FC } from "react";

import Banner from "web/Pages/PageGenerator/TousrismBanner/Banner";
import DomesticTourismForm, {
  DOMESTIC_TOURISM_FORM_VARIANTS,
} from "web/Pages/Tourism/DomesticTourismForm";

import CampaignGraphicsProvider from "web/Layout/CampaignGraphics/campaignGraphics";

import placements from "web/constants/campaignGraphics";

import { useAppContext } from "web/context/app";

import styles from "./tourismBanner.scss";

interface IPageGeneratorTourismBannerProps {
  url?: string;
  imageSrc?: string;
  categoryUrl?: string;
  buttonTitle?: string;
  isButtonVisible?: boolean;
  alt?: string;
}

const PageGeneratorTourismBanner: FC<IPageGeneratorTourismBannerProps> = ({
  imageSrc = "",
  url = "",
  categoryUrl = "",
  buttonTitle = "",
  isButtonVisible = true,
  alt = "",
}) => {
  const { isMobile } = useAppContext();

  return (
    <div
      className={
        isMobile
          ? styles.tourismContainerMobile
          : styles.tourismContainerDesktop
      }
      data-t1="page_generator_tourism_banner"
    >
      <div className={`${styles.wrapper} container`}>
        <CampaignGraphicsProvider placement={placements.tourismBanner}>
          <DomesticTourismForm
            variant={DOMESTIC_TOURISM_FORM_VARIANTS.OFFER}
            categoryUrl={categoryUrl}
          />
        </CampaignGraphicsProvider>

        {!isMobile && (
          <Banner
            className={styles.banner}
            imageSrc={imageSrc}
            url={url}
            alt={alt}
            buttonTitle={buttonTitle}
            isButtonVisible={isButtonVisible}
          />
        )}
      </div>
    </div>
  );
};

export default PageGeneratorTourismBanner;
